import React, { useState, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import Navbar from "../components/common/Navbar";
import DocumentTable from "../components/document-table/DocumentTable";
import PdfViewer from "../components/pdf-viewer/PdfViewer";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { IoIosArrowDropleftCircle } from "react-icons/io";
import { IoIosArrowDroprightCircle } from "react-icons/io";

import "../styles/Documents.css";

const Documents = () => {
  const [tab, setTab] = useState([
    {
      id: uuidv4(),
      documentID: null,
      title: "All Documents",
      content: (
        addDocumentTab,
        showAddDocumentForm,
        onAddDocumentButtonClick
      ) => (
        <DocumentTable
          addDocumentTab={addDocumentTab}
          showAddDocumentForm={showAddDocumentForm}
          onAddDocumentButtonClick={onAddDocumentButtonClick}
        />
      ),
      canClose: false,
    },
  ]);
  const [tabValue, setTabValue] = useState(tab[0].id);

  const [showAddDocumentForm, setShowAddDocumentForm] = useState(false);
  const scrollRef = useRef(null);

  const truncate = (string, n) => {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  };

  const scrollLeft = (scrollOffset) => {
    scrollRef.current.scrollLeft += scrollOffset;
  };

  const scrollRight = (scrollOffset) => {
    scrollRef.current.scrollLeft -= scrollOffset;
  };

  const changeActiveTab = () => {
    setTabValue(tab[0].id);
  };

  const addDocumentTab = (document) => {
    const isDocumentAlreadySelected = tab.find(
      (tab) => tab.documentID === document.id
    );

    if (isDocumentAlreadySelected !== undefined) {
      return;
    }

    const findIndex = tab.splice(1, 0, {
      id: uuidv4(),
      documentID: document.id,
      title: truncate(document.document_title, 9),
      content: () => {
        return (
          <PdfViewer
            documentType={document.document_type}
            caseNumber={document.case_number}
            documentID={document.id}
            documentTitle={document.document_title}
            changeActiveTab={changeActiveTab}
          />
        );
      },
      canClose: true,
    });

    const filteredTab = tab.filter((value, index) => index !== findIndex);

    setTab(filteredTab);
  };

  const onAddDocumentButtonClick = () => {
    setShowAddDocumentForm(!showAddDocumentForm);
  };

  const handleChange = (index) => {
    setTabValue(index);
  };

  const closeTab = (e, index) => {
    e.stopPropagation();
    const newTab = tab.filter((tab) => tab.id !== index);
    const allDocumentTabId = newTab[0].id;
    setTab(newTab);
    setTabValue(allDocumentTabId);
  };

  return (
    <div className="document-container">
      <div className="navbar">
        <Navbar />
      </div>
      <div className="document-content">
        {!showAddDocumentForm ? (
          <div
            className={
              tab.length > 7 ? "scrollable-tabs" : "not-scrollable-tabs"
            }
          >
            {tab.length > 7 ? (
              <div className="scroll-icons" onClick={() => scrollRight(150)}>
                <IoIosArrowDropleftCircle />
              </div>
            ) : null}
            <div className="tabs-header" ref={scrollRef}>
              {tab.map((tab, index) => (
                <div
                  key={tab.id}
                  className={
                    tabValue === tab.id
                      ? "tab-title active-tab-title"
                      : "tab-title"
                  }
                  onClick={() => handleChange(tab.id)}
                >
                  <span>{tab.title}</span>
                  {tab.canClose ? (
                    <button
                      className="tab-close-icon"
                      onClick={(e) => closeTab(e, tab.id)}
                    >
                      <AiOutlineCloseCircle />
                    </button>
                  ) : null}
                </div>
              ))}
            </div>
            {tab.length > 7 ? (
              <div className="scroll-icons" onClick={() => scrollLeft(150)}>
                <IoIosArrowDroprightCircle />
              </div>
            ) : null}
          </div>
        ) : null}
        <div className="tab-content">
          {tab.map((tab, index) => {
            return tabValue === tab.id ? (
              <div key={index}>
                {tab.title === "All Documents"
                  ? tab.content(
                      addDocumentTab,
                      showAddDocumentForm,
                      onAddDocumentButtonClick
                    )
                  : tab.content()}
              </div>
            ) : null;
          })}
        </div>
      </div>
    </div>
  );
};

export default Documents;
